import React from 'react';
import { IndicativeHighlight } from 'web-ui-components/lib/typography/highlights';

const htmlTagPattern = /(<[^>]*>)/;
const htmlClosingTagPattern = /(<\/[^>]*>)/;

const getJSXfromElements = (element) => {
	if (element.tag === 'string') return element.value;
	if (element.tag.includes('<p')) return <p>{element.value}</p>;
	if (element.tag === '<IndicativeHighlight.description>') {
		return <IndicativeHighlight.description>{element.value}</IndicativeHighlight.description>;
	}
	if (element.tag === '<IndicativeHighlight.value>') {
		return <IndicativeHighlight.value>{element.value}</IndicativeHighlight.value>;
	}
	if (element.tag === '<br />') return <br />;

	return null;
};

const stringContainsHTMLTags = (stringToCheck) => htmlTagPattern.test(stringToCheck);

export const parseString = (stringToParse) => {
	if (stringToParse.length === 0) return '';
	if (!stringContainsHTMLTags(stringToParse)) return stringToParse;

	const tokens = stringToParse.split(htmlTagPattern);

	let insideTag = false;
	let currentTag = '';

	const elementArray = tokens.reduce((mapTokenToElements, token) => {
		if (token === '') return mapTokenToElements;

		const isToken = htmlTagPattern.test(token);
		const isClosingTag = htmlClosingTagPattern.test(token);

		if (token === '<br />') return [...mapTokenToElements, { tag: '<br />', value: '' }];

		if (isToken && !isClosingTag) {
			insideTag = true;
			currentTag = token;
			return mapTokenToElements;
		}

		if (isClosingTag) {
			insideTag = false;
			return mapTokenToElements;
		}

		if (!isToken && !insideTag) {
			currentTag = 'string';
		}

		return [...mapTokenToElements, { tag: currentTag, value: token }];
	}, []);

	return elementArray.map(getJSXfromElements);
};
